import styled from 'styled-components';

export default styled.div`
  width: 82%;
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  background-color: white;
  margin-top: 10px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 100px;
  border-radius: 4px;
`;
